export const sortingOptions = [
  { text: 'Стоимость по возрастанию', value: 'ASC_price' },
  { text: 'Стоимость по убыванию', value: 'DESC_price' },
  { text: 'Сначала ближайшие свободные даты', value: 'ASC_availability' },
  { text: 'Стаж по возрастанию', value: 'ASC_experience' },
  { text: 'Стаж по убыванию', value: 'DESC_experience' },
];
